<template>
    <vue-table-card title="Course Charge" :show-search-box="false" :fields="fields"
                    :url="listUrl" :show-pagination="false" ref="table" :extra-params="{course: id}">
        <template #buttons>
            <btn color="success" icon="fa fa-plus" size="sm" @click="$refs.addModal.show()" text="Add"/>
        </template>

        <template #actions="{rowData}">
            <div class="btn-group-tight">
                <btn size="xs" text="View" @click="setEdit(rowData)"/>
                <delete-btn v-if="!checkIfPublished" @click="setDelete(rowData)"/>
            </div>
        </template>

<!--        <template #total="{rowData}">-->
<!--            <div>{{parseInt(rowData.rate) * parseInt(rowData.days)}}</div>-->
<!--        </template>-->
        <template #total="{rowData}">
                <div>{{ (parseFloat(rowData.rate) * parseInt(rowData.days)).toFixed(2) }}</div>
        </template>

        <template #footer>
            <modal title="Course Charge" ref="addModal" width="40r" header-color="primary" no-close-on-backdrop>
                <add-course-charge @success="formSuccess" :course="id"/>
            </modal>

            <modal title="Course Charge" ref="editModal" width="40r" header-color="primary" no-close-on-backdrop>
                <edit-course-charge :checkIfPublished="checkIfPublished" :initial-data="editingItem" :course="id"
                                    @success="formSuccess"/>
            </modal>

            <delete-modal ref="deleteModal" :url="deleteUrl" :params="deletingItem" @response="deleteComplete">
                <p>You are about to delete the item <b v-html="deletingItem && deletingItem.name"></b>. Are you sure ?
                </p>

                <template #loading>
                    <loading-animation/>
                    Please wait while we delete <b v-html="deletingItem && deletingItem.name"></b>.
                </template>
            </delete-modal>
        </template>

    </vue-table-card>
</template>

<script>
import urls from '../../../../data/urls';
import AddCourseCharge from './AddCourseCharge';
import EditCourseCharge from './EditCourseCharge';

export default {
    name: 'CourseCharge',
    props: {
        checkIfPublished: { type: Boolean, default: false }
    },
    components: { EditCourseCharge, AddCourseCharge },
    data () {
        return {
            id: this.$route.params.id,
            listUrl: urls.admin.course.detailsUrl.charge.list,
            addUrl: urls.admin.course.detailsUrl.charge.addEdit,
            deleteUrl: urls.admin.course.detailsUrl.charge.delete,
            editingItem: null,
            deletingItem: null,
            fields: [
                {
                    name: 'charge_type',
                    sortField: 'charge_type',
                    title: 'Charge Type'
                },
                {
                    name: 'days',
                    sortField: 'days',
                    title: 'Days'
                },
                {
                    name: 'rate',
                    sortField: 'rate',
                    title: 'Rate/Day'
                },
                {
                    name: '__slot:total',
                    title: 'Total'
                },
                {
                    name: '__slot:actions',
                    titleClass: 'center aligned text-right',
                    dataClass: 'aligned text-right'
                }
            ]
        };
    },
    methods: {
        viewFile (file) {
            window.open(file);
        },
        formSuccess (response) {
            this.$emit('updateCourseFee', response.data.course_fee);
            const refs = this.$refs;
            refs.addModal.close();
            refs.editModal.close();
            refs.table.refreshTable();

            this.editingItem = null;
        },

        setEdit (item) {
            this.editingItem = { ...item };
            this.$refs.editModal.show();
        },

        setDelete (item) {
            this.deletingItem = { ...item };
            this.deletingItem.course = this.id;
            this.$refs.deleteModal.show();
        },

        deleteComplete (response) {
            this.$emit('updateCourseFee', response.course_fee);
            this.deletingItem = null;
            this.$refs.deleteModal.close();
            this.$notify('Deleted Successfully', 'Success', {
                type: 'success'
            });
            this.$refs.table.refreshTable();
        }
    }
};
</script>
